module.exports = __webpack_public_path__ + "static/media/3-web-or-mls-DSC06960.e8fb9342.jpg";